import { render } from "./WorkBillBoardInquiry.vue?vue&type=template&id=39c495b4"
import script from "./WorkBillBoardInquiry.vue?vue&type=script&lang=js"
export * from "./WorkBillBoardInquiry.vue?vue&type=script&lang=js"

import "./WorkBillBoardInquiry.vue?vue&type=style&index=0&id=39c495b4&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__